import * as React from 'react';
import TopBar from '../components/common/TopBar';
import SelectDefaults from '../components/defaults/SelectDefaults';

import { useSetTitle } from '../components/hooks/useSetTitle';

export interface SelectDefaultsPageProps {}

const SelectDefaultsPage: React.FC<SelectDefaultsPageProps> = () => {
  useSetTitle(`Select Data Pool`);
  return (
    <div id="select-defaults-page">
      <TopBar />
      <SelectDefaults />
    </div>
  );
};

export default SelectDefaultsPage;
